import axios, { axiosNT } from '../../../services/axios';
import { CourseTagsBody } from '../types/CourseTagsBody';

const list = (limit:number, skip:number) => axios.get(`/courseTag/?limit=${limit}&skip=${skip}`)
	.then((res: any) => Promise.resolve(res.responseObject));

const byId = (id: string) => axios.get(`/courseTag/${id}`)
	.then((res: any) => Promise.resolve(res.responseObject));

const create = (postData: CourseTagsBody) => axios.post('/courseTag', postData)
	.then((res: any) => Promise.resolve(res.responseObject));

const update = (postData: CourseTagsBody, id: string) => axios.patch(`/courseTag/${id}`, postData)
	.then((res: any) => Promise.resolve(res.responseObject));

const remove = (id: string) => axios.delete(`/courseTag/${id}`)
	.then((res: any) => Promise.resolve(res.responseObject));

const tagTypes = () => axiosNT.get('/courseTag/getTagTypes')
	.then((res: any) => Promise.resolve(res.responseObject));

export default {
	list,
	byId,
	create,
	update,
	remove,
	tagTypes,
};